import React from 'react';
import { Theme, withStyles } from '@material-ui/core';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import CardLayout, { getCardLayoutStyles } from '../CardLayout';
import { DRIVER_MESSAGE_CONTENT, formatDriverMessageTitle } from '../../content';
import { NOTIFICATION_SEMIBOLD_CLASS } from '../../registerNotificationFonts';
import type { CardProps, DriverMessageItem, NotificationHandlers } from '../../types';
import MessageContent from './components/MessageContent';

type RouteMaxTheme = Theme & {
  textFontSize?: number;
  TextColor?: string;
};

type DriverMessageProps = CardProps<DriverMessageItem> & {
  classes: Record<string, string>;
  handlers: NotificationHandlers;
};

const DriverMessage = ({ classes, item, handlers }: DriverMessageProps) => {
  const openDriverChat = () => {
    if (!item.driver) {
      return;
    }
    handlers.openDriverChatBox(item.driver);
  };

  const driverDisplay = formatDriverMessageTitle(item.driver);

  return (
    <CardLayout
      classes={classes}
      icon={<MailOutlineIcon className={classes.icon} />}
      title={DRIVER_MESSAGE_CONTENT.title}
      body={
        <div className={classes.messageBody}>
          {driverDisplay ? (
            <div className={`${classes.driverName} ${NOTIFICATION_SEMIBOLD_CLASS}`}>
              {driverDisplay}
            </div>
          ) : null}
          <MessageContent item={item} />
        </div>
      }
      timestamp={item.timestamp}
      onClick={item.driver ? openDriverChat : undefined}
    />
  );
};

const styles = (theme: Theme) => {
  const routeMaxTheme = theme as RouteMaxTheme;

  return {
    ...getCardLayoutStyles(theme),
    icon: {
      color: theme.palette.primary.main,
      fontSize: 34,
    },
    driverName: {
      fontSize: routeMaxTheme.textFontSize,
      color: routeMaxTheme.TextColor,
      lineHeight: '18px',
      textTransform: 'uppercase',
      marginBottom: 4,
    },
    messageBody: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      minWidth: 0,
    },
  };
};

export default withStyles(styles as Parameters<typeof withStyles>[0])(DriverMessage);
